import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LandingPageCurveComponent } from '@landing-page/components/curve/landing-page-curve.component'

@NgModule({
    declarations: [LandingPageCurveComponent],
    imports: [CommonModule],
    exports: [LandingPageCurveComponent],
})
export class LandingPageCurveModule {}
